<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen" dir="rtl">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800">
        <span class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500">
          بروزرسانی قیمت با اکسل
        </span>
      </h1>
      <button
          @click="goBack"
          class="px-3 py-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 text-sm text-gray-700"
      >
        بازگشت به تغییر قیمت دسته‌جمعی
      </button>
    </div>

    <!-- Column-type popup -->
    <div v-if="popupVisible" class="fixed inset-0 bg-black/30 backdrop-blur-sm z-40" @click="popupVisible = false"></div>
    <div
        v-if="popupVisible"
        class="fixed z-50 bg-white/95 backdrop-blur-md shadow-lg rounded-lg p-4 border border-gray-200 max-w-xs w-full"
        :style="{ top: `${popupTopPosition}px`, left: '50%', transform: 'translateX(-50%)' }"
    >
      <div class="text-sm font-medium text-gray-700 mb-3">این ستون را به عنوان چه چیزی در نظر بگیریم؟</div>
      <button
          v-for="type in Object.keys(headerTypes)"
          :key="type"
          @click.stop="setHeaderType(type)"
          class="block w-full text-right px-4 py-2 text-sm rounded-lg mt-2 transition-colors"
          :class="headerColors[type].bg + ' ' + headerColors[type].text"
      >
        {{ headerTypes[type] }}
        <span v-if="typeForHeader(clickedHeaderIndex) === type" class="text-xs">(انتخاب شده - برای حذف کلیک کنید)</span>
      </button>
      <button
          @click.stop="popupVisible = false"
          class="block w-full text-right px-4 py-2 text-sm hover:bg-gray-100 text-gray-600 rounded-lg mt-3 transition-colors"
      >
        انصراف
      </button>
    </div>

    <!-- Step 1: Upload -->
    <div v-if="phase === 'upload'" class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 shadow-sm border border-gray-100">
      <div
          class="border-2 border-dashed border-blue-300 rounded-xl bg-white/50 p-8 text-center cursor-pointer transition-all duration-300 hover:bg-blue-50"
          @click="openFileDialog"
          @dragover.prevent="dragover = true"
          @dragleave="dragover = false"
          @drop.prevent="handleDrop"
          :class="{ 'border-blue-500 bg-blue-50/50': dragover }"
      >
        <div class="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
          </svg>
        </div>
        <h3 class="text-lg font-medium text-gray-800">فایل اکسل خود را اینجا رها کنید</h3>
        <p class="mt-1 text-sm text-gray-500">یا برای انتخاب فایل کلیک کنید (ستون‌های GTIN، قیمت مصرف‌کننده، قیمت پایه، درصد سود)</p>

        <input type="file" ref="fileInput" accept=".xls,.xlsx" @change="handleFileChange" class="hidden"/>

        <div v-if="loadingFile" class="mt-6 flex flex-col items-center">
          <svg class="animate-spin h-8 w-8 text-blue-600 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="text-sm text-gray-600">در حال خواندن فایل...</span>
        </div>

        <div v-if="error" class="mt-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">{{ error }}</div>
      </div>
    </div>

    <!-- Step 2: Column mapping + raw preview -->
    <div v-if="phase === 'mapping'" class="space-y-4">
      <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 shadow-sm border border-gray-100 flex items-center justify-between gap-4">
        <div class="text-sm text-gray-700">
          <span class="font-medium">{{ selectedFile && selectedFile.name }}</span>
          — {{ dataRows.length }} ردیف داده. روی هدر هر ستون کلیک کنید تا نوع آن را مشخص کنید.
        </div>
        <div class="flex gap-2">
          <button @click="resetForm" class="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg text-xs hover:bg-gray-200">
            آپلود فایل دیگر
          </button>
          <button
              @click="startMatching"
              :disabled="!canStartMatching"
              :class="[
                'px-4 py-2 text-sm rounded-lg shadow transition-all',
                canStartMatching ? 'bg-gradient-to-r from-blue-500 to-green-500 text-white hover:shadow-md' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              ]"
          >
            بارگذاری اطلاعات محصولات
          </button>
        </div>
      </div>
      <div v-if="!selectedHeaders.gtin" class="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
        برای ادامه، حتماً باید ستون GTIN (کد ۱۶ رقمی) مشخص شود.
      </div>

      <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full text-sm">
            <thead class="bg-gray-50">
            <tr>
              <th
                  v-for="idx in columnCount" :key="idx - 1"
                  @click="showHeaderPopup(idx - 1)"
                  class="p-3 text-center text-xs font-medium text-gray-600 cursor-pointer hover:bg-blue-100 border-b border-gray-200"
              >
                <div v-if="!typeForHeader(idx - 1)">{{ headerLabel(idx - 1) }}</div>
                <span v-else class="inline-block text-xs px-2 py-0.5 rounded-full" :class="headerColors[typeForHeader(idx - 1)].spanBg + ' ' + headerColors[typeForHeader(idx - 1)].spanText">
                  {{ headerTypes[typeForHeader(idx - 1)] }}
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, i) in dataRows.slice(0, 10)" :key="i" class="border-t border-gray-100 hover:bg-gray-50">
              <td
                  v-for="idx in columnCount" :key="idx - 1"
                  @click="showHeaderPopup(idx - 1)"
                  class="p-2 text-center text-xs text-gray-700 cursor-pointer"
                  :class="typeForHeader(idx - 1) ? (headerColors[typeForHeader(idx - 1)].spanBg + ' ' + headerColors[typeForHeader(idx - 1)].spanText) : ''"
              >
                {{ row[idx - 1] !== undefined && row[idx - 1] !== '' ? row[idx - 1] : '-' }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="dataRows.length > 10" class="p-3 text-center text-xs text-gray-500 border-t border-gray-100">
          و {{ dataRows.length - 10 }} ردیف دیگر ...
        </div>
      </div>
    </div>

    <!-- Step 3: Matching progress -->
    <div v-if="phase === 'matching'" class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-8 shadow-sm border border-gray-100 text-center">
      <svg class="animate-spin h-10 w-10 text-blue-600 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <p class="text-sm text-gray-700">در حال بررسی محصولات: {{ matchProgress.done }} از {{ matchProgress.total }}</p>
    </div>

    <!-- Step 4: Preview + apply -->
    <div v-if="phase === 'preview' || phase === 'applying' || phase === 'done'" class="space-y-4">
      <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 shadow-sm border border-gray-100">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-center text-xs">
          <div class="bg-green-50 border border-green-200 rounded-lg p-3">
            <div class="text-lg font-bold text-green-700">{{ matchedCount }}</div>
            <div class="text-green-800">تطبیق یافته</div>
          </div>
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <div class="text-lg font-bold text-blue-700">{{ changedRows.length }}</div>
            <div class="text-blue-800">دارای تغییر قیمت</div>
          </div>
          <div class="bg-red-50 border border-red-200 rounded-lg p-3">
            <div class="text-lg font-bold text-red-700">{{ notFoundRows.length }}</div>
            <div class="text-red-800">یافت نشد</div>
          </div>
          <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <div class="text-lg font-bold text-yellow-700">{{ ambiguousRows.length + notEditableRows.length }}</div>
            <div class="text-yellow-800">مبهم / غیرقابل تغییر</div>
          </div>
        </div>

        <p class="mt-4 text-sm text-amber-800">تخفیف تمام محصولاتی که به‌روزرسانی می‌شوند صفر می‌شود و قیمت فروش بدون تخفیف بازمحاسبه خواهد شد.</p>
        <div class="flex justify-between items-center mt-4">
          <div class="flex gap-2">
            <button @click="resetForm" class="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg text-xs hover:bg-gray-200">
              آپلود فایل دیگر
            </button>
            <button
                v-if="ambiguousRows.length"
                @click="showOnlyAmbiguous = !showOnlyAmbiguous"
                :class="[
                  'px-3 py-2 rounded-lg text-xs transition-all',
                  showOnlyAmbiguous ? 'bg-yellow-500 text-white' : 'bg-yellow-50 text-yellow-800 border border-yellow-200 hover:bg-yellow-100'
                ]"
            >
              {{ showOnlyAmbiguous ? 'نمایش همه ردیف‌ها' : `فقط مبهم‌ها (${ambiguousRows.length})` }}
            </button>
          </div>
          <button
              v-if="phase === 'preview'"
              @click="confirmAndApply"
              :disabled="changedRows.length === 0"
              :class="[
                'px-4 py-2 text-sm rounded-lg shadow transition-all',
                changedRows.length ? 'bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:shadow-md' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              ]"
          >
            اعمال تغییرات روی {{ changedRows.length }} محصول
          </button>
          <div v-if="phase === 'applying'" class="text-sm text-gray-700">
            در حال اعمال تغییرات روی سرور: {{ applyProgress.done }} از {{ applyProgress.total }}
            <span class="text-xs text-gray-400">(این پردازش روی سرور ادامه می‌یابد حتی اگر این صفحه بسته شود)</span>
          </div>
          <div v-if="phase === 'done'" class="text-sm">
            <span class="text-green-700 font-medium">{{ doneCount }} محصول با موفقیت بروزرسانی شد</span>
            <span v-if="errorCount" class="text-red-600 mr-3">{{ errorCount }} مورد با خطا</span>
          </div>
        </div>
      </div>

      <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full text-sm">
            <thead class="bg-gray-50">
            <tr>
              <th class="p-3 text-right text-xs font-medium text-gray-500">محصول</th>
              <th class="p-3 text-right text-xs font-medium text-gray-500">GTIN</th>
              <th class="p-3 text-right text-xs font-medium text-gray-500">قیمت مصرف‌کننده</th>
              <th class="p-3 text-right text-xs font-medium text-gray-500">قیمت پایه</th>
              <th class="p-3 text-right text-xs font-medium text-gray-500">درصد سود</th>
              <th class="p-3 text-right text-xs font-medium text-gray-500">وضعیت</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in visibleMatchedRows" :key="row._id" class="border-t border-gray-100 hover:bg-gray-50">
              <td class="p-3 text-xs">
                <div v-if="row.product" class="flex items-center gap-2">
                  <img v-if="row.product.image" :src="img_source(row.product.image)" class="w-8 h-8 rounded object-cover border border-gray-200">
                  <span>{{ row.product.name }}</span>
                </div>
                <span v-else class="text-gray-400">-</span>
              </td>
              <td class="p-3 text-xs">{{ row.gtin }}</td>
              <td class="p-3 text-xs">
                <template v-if="row.status === 'matched' && row.newValues.consumer_price != null">
                  <span v-if="row.newValues.consumer_price !== row.current.regular_price" dir="ltr" class="inline-flex items-center gap-1">
                    <span class="text-rose-600">{{ row.current.regular_price | toMoney }}</span>
                    <span>→</span>
                    <span class="text-emerald-600 font-medium">{{ row.newValues.consumer_price | toMoney }}</span>
                  </span>
                  <span v-else class="text-gray-500">{{ row.current.regular_price | toMoney }}</span>
                </template>
                <span v-else-if="row.status === 'matched'" class="text-gray-400">{{ row.current.regular_price | toMoney }}</span>
                <span v-else class="text-gray-300">-</span>
              </td>
              <td class="p-3 text-xs">
                <template v-if="row.status === 'matched' && row.hasCurrency">
                  <span class="text-amber-600" title="این محصول ارزی است؛ قیمت پایه آن به ارز خارجی ذخیره می‌شود و از این مسیر تغییر نمی‌کند">ارزی - بدون تغییر</span>
                </template>
                <template v-else-if="row.status === 'matched' && row.newValues.base_price != null">
                  <span v-if="row.newValues.base_price !== row.current.base_price" dir="ltr" class="inline-flex items-center gap-1">
                    <span class="text-rose-600">{{ row.current.base_price | toMoney }}</span>
                    <span>→</span>
                    <span class="text-emerald-600 font-medium">{{ row.newValues.base_price | toMoney }}</span>
                  </span>
                  <span v-else class="text-gray-500">{{ row.current.base_price | toMoney }}</span>
                </template>
                <span v-else-if="row.status === 'matched'" class="text-gray-400">{{ row.current.base_price | toMoney }}</span>
                <span v-else class="text-gray-300">-</span>
              </td>
              <td class="p-3 text-xs">
                <template v-if="row.status === 'matched' && row.newValues.profit_percent != null">
                  <span v-if="row.newValues.profit_percent !== row.current.profit_margin" dir="ltr" class="inline-flex items-center gap-1">
                    <span class="text-rose-600">{{ row.current.profit_margin }}%</span>
                    <span>→</span>
                    <span class="text-emerald-600 font-medium">{{ row.newValues.profit_percent }}%</span>
                  </span>
                  <span v-else class="text-gray-500">{{ row.current.profit_margin }}%</span>
                </template>
                <span v-else-if="row.status === 'matched'" class="text-gray-400">{{ row.current.profit_margin }}%</span>
                <span v-else class="text-gray-300">-</span>
              </td>
              <td class="p-3 text-xs">
                <span v-if="row.status === 'matched'" class="px-2 py-0.5 rounded-full bg-green-100 text-green-800">تطبیق یافته</span>
                <span v-else-if="row.status === 'not_found'" class="px-2 py-0.5 rounded-full bg-red-100 text-red-800">یافت نشد</span>
                <span v-else-if="row.status === 'ambiguous'" class="inline-flex items-center gap-2">
                  <span class="px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800">چند محصول یافت شد ({{ row.candidates.length }})</span>
                  <button @click="openResolveModal(row)" class="px-2 py-0.5 rounded-full bg-blue-600 text-white hover:bg-blue-700 text-[11px]">
                    انتخاب محصول
                  </button>
                </span>
                <span v-else-if="row.status === 'not_editable'" class="px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800">قابل تغییر نیست</span>
                <span v-else-if="row.status === 'checking'" class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">در حال بررسی...</span>
                <span v-else-if="row.status === 'applying'" class="px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">در حال ثبت...</span>
                <span v-else-if="row.status === 'done'" class="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800">ثبت شد ✓</span>
                <span v-else-if="row.status === 'error'" class="px-2 py-0.5 rounded-full bg-red-100 text-red-800" :title="row.errorMessage">خطا</span>
                <span v-else class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">در انتظار</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Ambiguous-row resolve modal -->
    <div v-if="resolveModalRow" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-40" @click="closeResolveModal"></div>
    <div v-if="resolveModalRow" class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div class="bg-white rounded-xl shadow-lg w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden">
        <div class="p-4 border-b border-gray-100">
          <h3 class="text-sm font-semibold text-gray-800">انتخاب محصول مقصد برای GTIN: {{ resolveModalRow.gtin }}</h3>
          <p class="text-xs text-gray-500 mt-1">چند محصول با این GTIN پیدا شد. یک یا چند محصول را که این تغییر قیمت باید روی آن‌ها اعمال شود انتخاب کنید.</p>
        </div>

        <div class="overflow-y-auto p-4 space-y-2">
          <label
              v-for="candidate in resolveModalRow.candidates"
              :key="candidate.id"
              class="flex items-center gap-3 p-2 rounded-lg border cursor-pointer transition-colors"
              :class="resolveSelectedIds.includes(candidate.id) ? 'border-blue-400 bg-blue-50' : 'border-gray-200 hover:bg-gray-50'"
          >
            <input
                type="checkbox"
                :checked="resolveSelectedIds.includes(candidate.id)"
                @change="toggleCandidateSelection(candidate.id)"
                class="w-4 h-4"
            >
            <img v-if="candidate.image" :src="img_source(candidate.image)" class="w-10 h-10 rounded object-cover border border-gray-200 flex-shrink-0">
            <div v-else class="w-10 h-10 rounded bg-gray-100 flex-shrink-0"></div>
            <div class="flex-1 min-w-0">
              <div class="text-xs font-medium text-gray-800 truncate">{{ candidate.name }}</div>
              <div class="text-[11px] text-gray-500 mt-0.5">شناسه: {{ candidate.id }} — {{ getTypeLabel(candidate.product_type) }}</div>
            </div>
            <div class="text-left flex-shrink-0">
              <div class="text-xs text-gray-700">{{ candidate.price | toMoney }} تومان</div>
              <div class="text-[11px] text-gray-500 mt-0.5">موجودی: {{ candidate.calculate_current_inventory != null ? toMoney(candidate.calculate_current_inventory) : '-' }}</div>
            </div>
          </label>
        </div>

        <div class="p-4 border-t border-gray-100 flex justify-between items-center">
          <button @click="closeResolveModal" class="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg text-xs hover:bg-gray-200">
            انصراف
          </button>
          <button
              @click="confirmResolveAmbiguous"
              :disabled="!resolveSelectedIds.length"
              :class="[
                'px-4 py-2 text-xs rounded-lg shadow transition-all',
                resolveSelectedIds.length ? 'bg-gradient-to-r from-blue-500 to-green-500 text-white hover:shadow-md' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              ]"
          >
            {{ `تایید (${resolveSelectedIds.length} انتخاب شده)` }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  name: 'DomesticPriceChangeExcelUpdate',
  data() {
    return {
      TOMAN_CURRENCY_ID: 19,
      LOOKUP_BATCH_SIZE: 300,
      LOOKUP_BATCH_CONCURRENCY: 3,
      applyJobId: null,
      phase: 'upload', // upload | mapping | matching | preview | applying | done
      selectedFile: null,
      loadingFile: false,
      error: '',
      dragover: false,

      rawHeaders: [],
      dataRows: [],
      columnCount: 0,

      selectedHeaders: {},
      headerTypes: {
        gtin: 'GTIN (کد ۱۶ رقمی محصول)',
        consumer_price: 'قیمت مصرف‌کننده',
        base_price: 'قیمت پایه',
        profit_percent: 'درصد سود',
      },
      headerColors: {
        gtin: {bg: 'hover:bg-orange-50', text: 'text-orange-600', spanBg: 'bg-orange-100', spanText: 'text-orange-700'},
        consumer_price: {bg: 'hover:bg-red-50', text: 'text-red-600', spanBg: 'bg-red-100', spanText: 'text-red-800'},
        base_price: {bg: 'hover:bg-blue-50', text: 'text-blue-600', spanBg: 'bg-blue-100', spanText: 'text-blue-800'},
        profit_percent: {bg: 'hover:bg-green-50', text: 'text-green-600', spanBg: 'bg-green-100', spanText: 'text-green-800'},
      },
      popupVisible: false,
      clickedHeaderIndex: null,
      popupTopPosition: 100,

      matchedRows: [],
      matchProgress: {done: 0, total: 0},
      applyProgress: {done: 0, total: 0},
      nextRowId: 1,

      showOnlyAmbiguous: false,
      resolveModalRow: null,
      resolveSelectedIds: [],
    }
  },
  computed: {
    canStartMatching() {
      const h = this.selectedHeaders
      return h.gtin !== undefined && (h.consumer_price !== undefined || h.base_price !== undefined || h.profit_percent !== undefined)
    },
    matchedCount() {
      return this.matchedRows.filter(r => r.status === 'matched' || r.status === 'applying' || r.status === 'done' || r.status === 'error').length
    },
    notFoundRows() {
      return this.matchedRows.filter(r => r.status === 'not_found')
    },
    ambiguousRows() {
      return this.matchedRows.filter(r => r.status === 'ambiguous')
    },
    notEditableRows() {
      return this.matchedRows.filter(r => r.status === 'not_editable')
    },
    changedRows() {
      return this.matchedRows.filter(r => r.status === 'matched' && this.rowHasChange(r))
    },
    doneCount() {
      return this.matchedRows.filter(r => r.status === 'done').length
    },
    errorCount() {
      return this.matchedRows.filter(r => r.status === 'error').length
    },
    visibleMatchedRows() {
      return this.showOnlyAmbiguous ? this.ambiguousRows : this.matchedRows
    },
  },
  methods: {
    goBack() {
      this.$router.push({name: 'DomesticPriceChange'})
    },
    getTypeLabel(type) {
      const typeMap = {simple: 'ساده', variable: 'دارای متغیر', variation: 'متغیر'}
      return typeMap[type] || type || ' '
    },

    openFileDialog() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) this.loadFile(file)
    },
    handleDrop(e) {
      this.dragover = false
      if (e.dataTransfer.files.length) this.loadFile(e.dataTransfer.files[0])
    },

    async loadFile(file) {
      this.selectedFile = file
      this.error = ''
      this.loadingFile = true
      try {
        const buffer = await file.arrayBuffer()
        const wb = XLSX.read(buffer, {type: 'array'})
        const sheetName = wb.SheetNames[0]
        const ws = wb.Sheets[sheetName]
        const aoa = XLSX.utils.sheet_to_json(ws, {header: 1, defval: ''})

        if (!aoa.length) {
          this.error = 'فایل انتخاب شده خالی است.'
          this.loadingFile = false
          return
        }

        this.rawHeaders = (aoa[0] || []).map(h => (h === undefined || h === null || h === '') ? null : String(h))
        this.dataRows = aoa.slice(1).filter(r => Array.isArray(r) && r.some(c => c !== '' && c !== null && c !== undefined))
        this.columnCount = this.dataRows.reduce((max, r) => Math.max(max, r.length), this.rawHeaders.length)
        this.selectedHeaders = {}

        if (!this.dataRows.length) {
          this.error = 'هیچ ردیف داده‌ای در فایل پیدا نشد.'
          this.loadingFile = false
          return
        }

        this.phase = 'mapping'
      } catch (err) {
        this.error = 'خطا در خواندن فایل اکسل. لطفاً فرمت فایل را بررسی کنید.'
      } finally {
        this.loadingFile = false
      }
    },

    resetForm() {
      this.phase = 'upload'
      this.selectedFile = null
      this.error = ''
      this.rawHeaders = []
      this.dataRows = []
      this.columnCount = 0
      this.selectedHeaders = {}
      this.matchedRows = []
      this.matchProgress = {done: 0, total: 0}
      this.applyProgress = {done: 0, total: 0}
      this.showOnlyAmbiguous = false
      this.resolveModalRow = null
      this.resolveSelectedIds = []
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },

    headerLabel(idx) {
      return this.rawHeaders[idx] || `ستون ${idx + 1}`
    },
    typeForHeader(idx) {
      for (const [type, i] of Object.entries(this.selectedHeaders)) {
        if (i === idx) return type
      }
      return null
    },
    showHeaderPopup(idx) {
      this.clickedHeaderIndex = idx
      this.popupTopPosition = window.scrollY + 150
      this.popupVisible = true
    },
    setHeaderType(type) {
      const idx = this.clickedHeaderIndex
      if (this.selectedHeaders[type] === idx) {
        this.$delete(this.selectedHeaders, type)
      } else {
        for (const key in this.selectedHeaders) {
          if (this.selectedHeaders[key] === idx) this.$delete(this.selectedHeaders, key)
        }
        this.$set(this.selectedHeaders, type, idx)
      }
      this.popupVisible = false
    },

    normalizeDigits(val) {
      if (val === null || val === undefined) return ''
      let s = String(val).trim()
      const persian = '۰۱۲۳۴۵۶۷۸۹'
      const arabic = '٠١٢٣٤٥٦٧٨٩'
      s = s.replace(/[۰-۹]/g, d => String(persian.indexOf(d)))
      s = s.replace(/[٠-٩]/g, d => String(arabic.indexOf(d)))
      return s.replace(/\s+/g, '')
    },
    parseNumber(val) {
      if (val === null || val === undefined || val === '') return null
      const s = this.normalizeDigits(val).replace(/,/g, '')
      const n = parseFloat(s)
      return isNaN(n) ? null : n
    },

    requestAsync(opts, retriesLeft = 3) {
      return new Promise((resolve, reject) => {
        this.request({
          ...opts,
          success: (res) => resolve(res),
          error: (e) => {
            // Higher concurrency can occasionally trip the backend's rate limit —
            // back off briefly and retry instead of failing the whole row.
            const status = e && e.response && e.response.status
            if (status === 429 && retriesLeft > 0) {
              const delay = (4 - retriesLeft) * 1200
              setTimeout(() => {
                this.requestAsync(opts, retriesLeft - 1).then(resolve).catch(reject)
              }, delay)
            } else {
              reject(e)
            }
          },
        })
      })
    },
    extractErrMsg(err) {
      if (Array.isArray(err) && err.length && err[0] && err[0].messages && err[0].messages.length) {
        return err[0].messages[0]
      }
      if (err && err.detail) return err.detail
      if (err && typeof err === 'object') {
        const keys = Object.keys(err)
        if (keys.length && Array.isArray(err[keys[0]]) && err[keys[0]].length) return err[keys[0]][0]
      }
      return 'خطای نامشخص'
    },

    async runWithConcurrency(items, worker, concurrency, onProgress) {
      let index = 0
      let completed = 0
      const total = items.length
      const runners = new Array(Math.min(concurrency, total) || 1).fill(0).map(async () => {
        while (index < total) {
          const i = index++
          await worker(items[i])
          completed++
          if (onProgress) onProgress(completed, total)
        }
      })
      await Promise.all(runners)
    },

    waitForPaint() {
      return new Promise(resolve => setTimeout(resolve, 0))
    },

    async startMatching() {
      // Show the loading state first, then yield to the browser so it actually
      // paints before the (potentially heavy, synchronous) row-building work
      // below runs — otherwise a large file can freeze the UI with no feedback.
      this.phase = 'matching'
      this.matchProgress = {done: 0, total: this.dataRows.length}
      await this.waitForPaint()

      const gtinCol = this.selectedHeaders.gtin
      const priceCol = this.selectedHeaders.consumer_price
      const baseCol = this.selectedHeaders.base_price
      const profitCol = this.selectedHeaders.profit_percent

      this.matchedRows = this.dataRows
          .map(r => ({
            _id: this.nextRowId++,
            gtin: this.normalizeDigits(r[gtinCol]),
            newValues: {
              consumer_price: priceCol !== undefined ? this.parseNumber(r[priceCol]) : undefined,
              base_price: baseCol !== undefined ? this.parseNumber(r[baseCol]) : undefined,
              profit_percent: profitCol !== undefined ? this.parseNumber(r[profitCol]) : undefined,
            },
            status: 'pending',
            product: null,
            current: null,
            hasCurrency: false,
            candidates: [],
            errorMessage: '',
          }))
          .filter(row => row.gtin)

      this.matchProgress = {done: 0, total: this.matchedRows.length}

      // Group rows by GTIN so a code repeated across many rows is only looked
      // up once, then batch the unique codes into a handful of bulk requests
      // instead of 1-2 requests per row (huge win for files with thousands
      // of rows — see product/bulkPricingLookup on the backend).
      const rowsByGtin = new Map()
      for (const row of this.matchedRows) {
        if (!rowsByGtin.has(row.gtin)) rowsByGtin.set(row.gtin, [])
        rowsByGtin.get(row.gtin).push(row)
      }
      const uniqueCodes = Array.from(rowsByGtin.keys())

      const batches = []
      for (let i = 0; i < uniqueCodes.length; i += this.LOOKUP_BATCH_SIZE) {
        batches.push(uniqueCodes.slice(i, i + this.LOOKUP_BATCH_SIZE))
      }

      let done = 0
      await this.runWithConcurrency(
          batches,
          async (batchCodes) => {
            let resultsByCode = {}
            let batchError = null
            try {
              const data = await this.requestAsync({
                url: this.endpoint('product/bulkPricingLookup'),
                method: 'post',
                data: {codes: batchCodes},
                loading: false,
              })
              resultsByCode = data.results || {}
            } catch (e) {
              batchError = this.extractErrMsg(e)
            }

            for (const code of batchCodes) {
              const rowsForCode = rowsByGtin.get(code) || []
              for (const row of rowsForCode) {
                if (batchError) {
                  row.status = 'error'
                  row.errorMessage = batchError
                } else {
                  this.applyLookupResult(row, resultsByCode[code] || [])
                }
                done++
              }
            }
            this.matchProgress = {done, total: this.matchedRows.length}
          },
          this.LOOKUP_BATCH_CONCURRENCY,
      )

      this.phase = 'preview'
    },

    applyLookupResult(row, matches) {
      if (matches.length === 0) {
        row.status = 'not_found'
        return
      }
      if (matches.length > 1) {
        row.candidates = matches
        row.status = 'ambiguous'
        return
      }
      this.applyProductToRow(row, matches[0])
    },

    applyProductToRow(row, product) {
      row.product = product
      // currency id 19 is "تومان" (Toman) itself — base price is still Toman-denominated
      // for it (and for products with no currency at all), so only real foreign
      // currencies should block a direct base-price overwrite.
      row.hasCurrency = !!product.currency && Number(product.currency) !== this.TOMAN_CURRENCY_ID
      row.current = this.buildCurrentSnapshot(product)
      row.status = 'matched'
    },

    buildCurrentSnapshot(obj) {
      return {
        price: Number(obj.price || 0),
        base_price: Number(obj.base_price || 0),
        regular_price: Number(obj.regular_price || 0),
        profit_type: obj.profit_type || 'percent',
        profit_margin: Number(obj.profit_margin || 0),
        discount_type: obj.discount_type || 'percent',
        discount_margin: Number(obj.discount_margin || 0),
        shipping_cost: Number(obj.shipping_cost || 0),
      }
    },

    openResolveModal(row) {
      this.resolveModalRow = row
      this.resolveSelectedIds = []
    },
    closeResolveModal() {
      this.resolveModalRow = null
      this.resolveSelectedIds = []
    },
    toggleCandidateSelection(id) {
      const idx = this.resolveSelectedIds.indexOf(id)
      if (idx === -1) this.resolveSelectedIds.push(id)
      else this.resolveSelectedIds.splice(idx, 1)
    },
    confirmResolveAmbiguous() {
      if (!this.resolveModalRow || !this.resolveSelectedIds.length) return
      const sourceRow = this.resolveModalRow
      const chosenCandidates = sourceRow.candidates.filter(c => this.resolveSelectedIds.includes(c.id))

      const newRows = chosenCandidates.map(candidate => {
        const newRow = {
          _id: this.nextRowId++,
          gtin: sourceRow.gtin,
          newValues: {...sourceRow.newValues},
          status: 'pending',
          product: null,
          current: null,
          hasCurrency: false,
          candidates: [],
          errorMessage: '',
        }
        this.applyProductToRow(newRow, candidate)
        return newRow
      })

      const idx = this.matchedRows.findIndex(r => r._id === sourceRow._id)
      if (idx !== -1) {
        this.matchedRows.splice(idx, 1, ...newRows)
      }

      this.closeResolveModal()
    },

    rowHasChange(row) {
      if (row.status !== 'matched' || !row.current) return false
      const nv = row.newValues
      if (nv.consumer_price != null && nv.consumer_price !== row.current.regular_price) return true
      if (nv.base_price != null && !row.hasCurrency && nv.base_price !== row.current.base_price) return true
      if (nv.profit_percent != null && nv.profit_percent !== row.current.profit_margin) return true
      return false
    },

    confirmAndApply() {
      const count = this.changedRows.length
      if (!count) return
      const ok = window.confirm(`آیا مطمئن هستید می‌خواهید قیمت ${count} محصول به مقادیر جدید تغییر کند و تخفیف آن‌ها صفر شود؟ این عملیات قابل بازگشت خودکار نیست.`)
      if (!ok) return
      this.applyChanges()
    },

    rowToPricingItem(row) {
      // "قیمت مصرف‌کننده" (consumer price) maps to regular_price — the actual
      // site sale price ("قیمت فروش" = `price`) is NOT sent here; the backend
      // (set_legend_pricing, triggered by legend_pricing: true) computes it
      // automatically from base_price + profit_margin, with the discount cleared.
      return {
        id: row.product.id,
        regular_price: row.newValues.consumer_price != null ? row.newValues.consumer_price : row.current.regular_price,
        legend_pricing: true,
        base_price: (row.newValues.base_price != null && !row.hasCurrency) ? row.newValues.base_price : row.current.base_price,
        profit_type: 'percent',
        profit_margin: row.newValues.profit_percent != null ? row.newValues.profit_percent : row.current.profit_margin,
        discount_type: 'percent',
        discount_margin: 0,
        shipping_cost: row.current.shipping_cost,
      }
    },

    async applyChanges() {
      this.phase = 'applying'
      const toApply = this.changedRows
      this.applyProgress = {done: 0, total: toApply.length}
      toApply.forEach(row => { row.status = 'applying' })

      // a product id is only ever targeted by one row within a single apply run
      const rowByProductId = new Map(toApply.map(row => [row.product.id, row]))
      const items = toApply.map(row => this.rowToPricingItem(row))

      try {
        // Submit the whole batch as one durable server-side job instead of
        // applying row-by-row from the client: the backend keeps processing
        // it (and its own progress) even if this tab is closed or the
        // connection drops — we just poll for status while it's open.
        const created = await this.requestAsync({
          url: this.endpoint('product/bulkPricingUpdateJob'),
          method: 'post',
          data: {items},
          loading: false,
        })
        this.applyJobId = created.job_id
        await this.pollApplyJob(created.job_id, rowByProductId, toApply.length)
      } catch (e) {
        const msg = this.extractErrMsg(e)
        toApply.forEach(row => { row.status = 'error'; row.errorMessage = msg })
      }

      this.phase = 'done'
    },

    async pollApplyJob(jobId, rowByProductId, total) {
      const POLL_INTERVAL_MS = 1500
      while (true) {
        const res = await this.requestAsync({
          url: this.endpoint(`product/bulkPricingUpdateJob/${jobId}`),
          method: 'get',
          loading: false,
        })
        const result = res.result || {}
        this.applyProgress = {done: result.processed || 0, total: result.total || total}

        for (const item of (result.results || [])) {
          const row = rowByProductId.get(item.id)
          if (!row) continue
          if (item.success) {
            row.status = 'done'
          } else {
            row.status = 'error'
            row.errorMessage = typeof item.error === 'string' ? item.error : JSON.stringify(item.error)
          }
        }

        if (res.status === 'done' || res.status === 'failed') {
          if (res.status === 'failed') {
            for (const row of rowByProductId.values()) {
              if (row.status === 'applying') {
                row.status = 'error'
                row.errorMessage = res.error || 'پردازش سمت سرور ناتمام ماند'
              }
            }
          }
          return
        }

        await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS))
      }
    },
  },
}
</script>

<style scoped>
body {
  direction: rtl;
}
</style>
